/**
 * Routes where PWA can safely auto-refresh (no unsaved form state / critical UI state).
 * Only applies to routes where PwaUpdatePrompt is actually rendered (AppShell, ChildAccess, ChildDayView).
 */

export const PWA_JUST_UPDATED_KEY = "flyt_pwa_just_updated";

const SAFE_EXACT_PATHS = ["/dashboard", "/reports", "/child/access"] as const;

/**
 * Returns true if the given pathname is safe for automatic PWA refresh.
 * Safe: read-only with no local draft state (no open sheets/drawers/forms).
 */
export function isSafeRouteForPwaRefresh(pathname: string): boolean {
  return SAFE_EXACT_PATHS.includes(pathname as (typeof SAFE_EXACT_PATHS)[number]);
}
